//引入刚才的http.js文件
import https from "./http.js";
//设置个对象，就不用一个个暴露了，直接暴露对象
let apiFun = {};
let baseURLSdk = "https://sdk.chuangyouhy.com";
/* 获取列首页数据 */
apiFun.indexData = function(params) {
  return https.post("/index.php?g=box&m=index&a=index", params);
};
//  开服数据
apiFun.openService = function(params) {
  return https.post("/index.php?g=box&m=game&a=kaifu", params);
};
//  礼包列表
apiFun.giftBag = function(params) {
  return https.post("/index.php?g=box&m=packs&a=index", params);
};
//  礼包详情
apiFun.cardinfo = function(params) {
  return https.post("/index.php?g=box&m=packs&a=cardinfo", params);
};
//  客服列表
apiFun.service = function(params) {
  return https.post("/index.php?g=box&m=kefu&a=kefu", params);
};
//  客服详情
apiFun.serviceinfo = function(params) {
  return https.post("/index.php?g=box&m=kefu&a=kefu_info", params);
};
//  资讯中心列表
apiFun.realTimeInfo = function(params) {
  return https.post("/index.php?g=box&m=protal&a=index", params);
};
//  资讯详情
apiFun.newsinfo = function(params) {
  return https.post("/index.php?g=box&m=protal&a=newsinfo", params);
};
//  搜索接口
apiFun.searchGame = function(params) {
  return https.post("/index.php?g=box&m=index&a=search", params);
};
//  排行榜单接口
apiFun.rankingList = function(params) {
  return https.post("/index.php?g=box&m=game&a=top_agentapi", params);
};
//  H5接口
apiFun.HfiveData = function(params) {
  return https.post("/index.php?g=box&m=game&a=gameh5", params);
};
//  所有游戏展示接口
apiFun.allGame = function(params) {
  return https.post("/index.php?g=box&m=game&a=index", params);
};
//  所有游戏详情接口
apiFun.allGameinfo = function(params) {
  return https.post("/index.php?g=box&m=game&a=gameinfo", params);
};
//  游戏下载接口
apiFun.gameDown = function(params) {
  return https.post("/index.php?g=Api&m=Game&a=gamedown", params);
};
//  box游戏盒子的渠道信息
apiFun.Information = function(params) {
  return https.post("/index.php?g=box&m=index&a=site_info", params);
};
//  礼包码领取
apiFun.getpacks = function(params) {
  return https.post("/index.php?g=box&m=packs&a=getpacks", params);
};
//  app下载
apiFun.appDown = function(params) {
  return https.post("/index.php?g=box&m=index&a=site_info", params);
};
//  底部信息
apiFun.tailConfiguration = function(params) {
  return https.post("/index.php?g=box&m=index&a=tailConfiguration", params);
};
// 发送验证码
apiFun.sendMessage = function(params) {
  return https.post(
    baseURLSdk + "/index.php?g=api&m=userbox&a=send_message",
    params
  );
};
//  注册接口
apiFun.register = function(params) {
  return https.post(
    baseURLSdk + "/index.php?g=api&m=userbox&a=register",
    params
  );
};
//  短信验证接口
apiFun.checkSmscode = function(params) {
  return https.post(
    baseURLSdk + "/index.php?g=api&m=userbox&a=check_smscode",
    params
  );
};
//  找回密码接口
apiFun.forgetPassword = function(params) {
  return https.post(
    baseURLSdk + "/index.php?g=api&m=userbox&a=forget_password",
    params
  );
};
//  登录接口
apiFun.login = function(params) {
  return https.post(baseURLSdk + "/index.php?g=api&m=userbox&a=login", params);
};
//  box下载
apiFun.boxDown = function(params) {
  return https.post("/index.php?g=box&m=index&a=boxDown", params);
};
//暴露出这个对象
export default apiFun;



// WEBPACK FOOTER //
// ./src/api/api.js